var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button-container",class:{ 'fondo-on': _vm.fondo }},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"needle",class:{ 'needle-on': _vm.isOn }})])])
}
var staticRenderFns = []

export { render, staticRenderFns }